import { render } from "./SuperAdminMenuLayout.vue?vue&type=template&id=3082c98e"
import script from "./SuperAdminMenuLayout.vue?vue&type=script&lang=js"
export * from "./SuperAdminMenuLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__